import { IMobileAttachmentContent } from "./mobile-attachment-content.interface";

export class MobileAttachmentContentDto implements IMobileAttachmentContent {
  file_name: string;
  file_key?: string;
  file_content?: string; // Base64 encoded
}
